import { faChevronDown, faChevronUp } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Collapse, IconButton, TableCell, TableRow, Typography } from "@mui/material"
import { translate } from "app/language/service"
import { IForm } from "form/model"
import React from "react"
import { ISsp, ISspDeal } from "ssp/model"
import { FlexBox } from "ui/components/FlexBox"
import { SspDealList } from "./SspDealList"

interface ISspSspDealRowProps {
  form: IForm
  ssp: ISsp
  sspIndex: number // used by tests
  rowRenderIndex: number
}

export const SspSspDealRow = React.memo(({ form, ssp, rowRenderIndex, sspIndex }: ISspSspDealRowProps) => {
  const [open, setOpen] = React.useState(true)
  const allDeals: ISspDeal[] = form.screens.allSspDeals.filter(s => s.ssp_id === ssp.id)
  if (allDeals.length === 0) {
    return null
  }
  const campaignSspDeals = form.screens.campaignSspDeals.filter(s => s.ssp_id === ssp.id)
  return (
    <>
      <TableRow
        sx={{
          "& > *": { borderBottom: "unset" }
        }}>
        <TableCell component="th" scope="row" onClick={() => setOpen(!open)} sx={{ cursor: "pointer" }}>
          <FlexBox jc="start" gap>
            <Typography fontSize=".9rem" fontWeight={400} color="textPrimary">
              {ssp.name}
            </Typography>
            <Typography fontSize=".9rem" fontWeight={400} color="textSecondary">
              {translate("campaign.ssp-deal.included.count", `${campaignSspDeals.length} / ${allDeals.length}`)}
            </Typography>
          </FlexBox>
        </TableCell>
        <TableCell width="1rem">
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            <FontAwesomeIcon icon={open ? faChevronUp : faChevronDown} />
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow sx={{ p: "0 !important" }}>
        <TableCell sx={{ p: "0 !important", borderBottom: "none" }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <SspDealList
              form={form}
              allDeals={allDeals}
              selectedDeals={campaignSspDeals}
              rowRenderIndex={rowRenderIndex}
              sspIndex={sspIndex}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  )
})
